import React, { useEffect, useState } from 'react';
type CountdownProps = {
  startSeconds: number;
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  startSeconds
}: CountdownProps) {
  const [remaining, setRemaining] = useState(startSeconds);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const blocks = [{
    value: pad(Math.floor(remaining / 3600)),
    unit: 'HS'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    unit: 'MIN'
  }, {
    value: pad(remaining % 60),
    unit: 'SEG'
  }];
  return <div className="flex items-start justify-center gap-2 sm:gap-4" role="timer" aria-live="off" data-id="element-41" data-mp="372je50jmyjr9">
      {blocks.map((block, index) => <React.Fragment key={block.unit} data-id="element-42" data-mp="10d4qjro5mek9" data-mpi={index}>
          <div className="text-center" data-id="element-43" data-mp="15b6dinopay10">
            <span className="block animate-blink text-4xl font-extrabold leading-none tracking-tight text-blood-500 tabular-nums sm:text-6xl" data-id="element-44" data-mp="15awiumspo2oz">
              {block.value}
            </span>
            <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.2em] text-neutral-400 sm:text-xs" data-id="element-45" data-mp="t1agj9pgmcam">
              {block.unit}
            </span>
          </div>
          {index < blocks.length - 1 && <span aria-hidden="true" className="animate-blink text-3xl font-extrabold leading-none text-blood-500 sm:text-5xl" data-id="element-46" data-mp="12sojxskj7w91">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}